import { Icon } from '@honeycomb-npm/honeycomb-react';
import { useEffect, useRef } from 'react';

type Props = {
  id: string;
  children?: JSX.Element | string | null;
  bladeHeadingIcon?: string;
  isMainHeading?: boolean;
  isFocused?: boolean;
}

const BladeHeading = ({
    bladeHeadingIcon, id, children, isMainHeading, isFocused,
}: Props) => {
    const ref = useRef<HTMLHeadingElement>(null);

    useEffect(() => {
        if(isFocused) {
            ref.current?.focus();
        }
    }, [isFocused]);

    const headingContent =  () => {
        const HeadingTag = isMainHeading ? 'h1' : 'h2';
        const HeadingClassNames = isMainHeading ? 'h1 mt-4' : 'h1';

        return (
            <HeadingTag id={id} className={HeadingClassNames} tabIndex={-1} ref={ref}>{children}</HeadingTag>
        );};

    return (
        <>
            {bladeHeadingIcon
                ? (
                    <Icon symbol={bladeHeadingIcon} iconClassName="mt-4">
                        {headingContent()}
                    </Icon>)
                : (
                    <>
                        {headingContent()}
                    </>)
            }
        </>
    );};

export default BladeHeading;
